//import axios from 'axios'
import axios from './axiosConfig'

export default {

    async returnFormData(payload) {
        return await axios({
            url: '/get/form/data',
            data: JSON.parse(JSON.stringify(payload)),
            method: 'POST'
        });
    },
    async createArticles(payload) {
        return await axios({
            url: `/${window._locale}/` +'create/user/articles',
            data: JSON.parse(JSON.stringify(payload)),
            method: 'POST'
        });
    },
    async returnArticleImageUrl(payload) {
        return await axios({
            url: '/get/article/image/url',
            data: JSON.parse(JSON.stringify(payload)),
            method: 'POST'
        });
    },
    async returnUserArticles(payload) {
        return await axios({
            url: `/${window._locale}/`+'get/user/articles', //`/${window._locale}/`+'
            data: JSON.parse(JSON.stringify(payload)),
            method: 'POST'
        });
    },


    async getAcousticDistanceData() {
        return axios.post('/api/get/acousticdistancedata');
    },
    async getClients(payload) {
        return await axios({
            url: '/get/clients', 
            data: JSON.parse(JSON.stringify(payload)),
            method: 'POST'
        });
    },

    
    
    
}